import { toast } from 'react-toastify';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import config from '../../config';
import { notifyMessage } from '../../components/Error/ErrorBoundary';

export const ADD_ERROR = 'ADD_ERROR';
export const REMOVE_ERROR = 'REMOVE_ERROR';

// Set in App.js
// const position = 'top-right';
// const effect = 'flip';
// const timeout = 3000;

export function displayErrors(type, message) {
    // console.log(type, message);
    // return {
    //     type: TRIGGER_ERROR,
    //     error: {
    //         type: type,
    //         message: message
    //     }
    // }
    message = message.message || message;
    if(message && typeof message === 'string') {
        switch(type) {
            case 'error':
                toast.error(message);
                break;

            case 'warning':
                toast.warning(message);
                break;

            case 'info':
                toast.info(message);
                break;

            case 'success':
                toast.success(message);
                break;

            default:
                toast(`${type} : ${message}`);
        }
    } else if(message !== 'Unauthorized') {
        console.error(message);
    } else {
        // console.log(message);
    }
    // Notify bug tracker
    // type === 'error' && notifyMessage(message, type);
}

export async function confirmAction(texts = { title: '', message: '', confirm: '', cancel: '' }, actions = { onConfirm: () => {}, onCancel: () => {} }) {
    const title = (texts || {}).title || ((texts || {}).formatMessage && texts.formatMessage({ id: 'confirmActionTitle', defaultMessage: 'Are you sure?' })) || 'Are you sure?';
    const message = (texts || {}).message || ((texts || {}).formatMessage && texts.formatMessage({ id: 'confirmActionText', defaultMessage: 'Please confirm your action' })) || 'Please confirm your action';
    const confirmText = (texts || {}).confirm || ((texts || {}).formatMessage && texts.formatMessage({ id: 'confirmActionConfirm', defaultMessage: 'I confirm' })) || 'Confirm';
    const cancelText = (texts || {}).cancel || ((texts || {}).formatMessage && texts.formatMessage({ id: 'confirmActionCacnel', defaultMessage: 'Cancel' })) || 'Cancel';

    confirmAlert({
        title: title || 'Are you sure ?', // Title dialog
        message: message || 'Please confirm your action', // Message dialog
        buttons: [
            {
              label: confirmText,
              onClick: (actions || {}).onConfirm || (() => {}),
            },
            {
              label: cancelText,
              onClick: (actions || {}).onCancel || (() => {}),
            },
          ],
    });
}

export function initNotification() {
	return new Promise((resolve, reject) => {
		if(!('Notification' in window)) {
			console.log('Ce navigateur ne prend pas en charge les notifications.');
			return resolve(false);
		}
		if (Notification.permission === "granted") {
			return resolve(true);
		}
		console.log('Notification: Init', 'requestPermission' in Notification);
		if('requestPermission' in Notification) {
			Notification.requestPermission().then(permission => {
				console.log('Notification: Request permission', permission);
				// Quelque soit la réponse de l'utilisateur, nous nous assurons de stocker cette information
				if(!('permission' in Notification)) {
					Notification.permission = permission;
				}

				// Si l'utilisateur est OK, on crée une notification
				return resolve(permission === 'granted');
			}).catch(err => {
				console.error('Notification: Error', err);
				resolve(false);
			});
		} else {
			resolve(false);
		}
	})
}

export function sendNotification(message) {
    if(message && window.Notification && typeof window.Notification !== 'undefined') {
        if(Notification.permission === 'granted') {
            console.log(`${config.url}assets/images/favicon.png`);
            const myNotification = new Notification(config.application.name, {
                body: message,
                icon: `${config.url}assets/images/favicon.png`,
            });
        } else if(Notification.permission !== 'denied') {
            initNotification().then(() => sendNotification(message));
        }
    } else {
        (typeof Notification === 'undefined' || !Notification) && console.error('Missing Notification module');
    }
}

export function addError(error, type = 'error') {
    return {
        type: ADD_ERROR,
        error: {
            message: error.message || error,
            type,
        },
    };
}

export function removeError(error) {
    return {
        type: REMOVE_ERROR,
        error,
    };
}
